import { type PrevisitFormFieldWithConfig } from './formField.js';
import { type PrevisitFormTemplatePageConfig } from './formTemplatePageConfig.js';
import { type BaseRecommendationTemplate } from '../recommendationTemplate.js';

export enum ExportMode {
  RunAutoExport = 'RUN_AUTO_EXPORT',
  NoAutoExport = 'NO_AUTO_EXPORT',
}

export enum Status {
  Created = 'CREATED',
  Started = 'STARTED',
  Completed = 'COMPLETED',
}

export interface SchedulingConfig {
  practiceIds: string[];
  providerUserIds?: string[];
  appointmentTypes?: string[];
}

export interface PrevisitFormContext {
  patientPrimaryCareProviderId?: string;
  patientOrderId?: string;
  patientOrderIds?: string[];
  temporalWorkflowId?: string;
  schedulingConfig?: SchedulingConfig;
}

export interface PrevisitForm {
  id: string;
  displayName: string;
  fields: PrevisitFormFieldWithConfig[];
  pageConfigs: Record<number, PrevisitFormTemplatePageConfig>;
  hideWhenCompleted: boolean;
  name: string;
  previsitFormTemplateId: string;
  previsitFormSetId: string;
  status: Status;
  score: number | null;
  scores: Record<string, number> | null;
  isReviewable: boolean | null;
  labels: string[] | null;
  context: PrevisitFormContext | null;
  isRecommendationForm?: boolean;
  recommendation?: BaseRecommendationTemplate['localizations'];
}

export const DEFAULT_SCORE_TYPE = 'default';
